export const MARRIOTT_STATE_PARAM_VALUE = 'marriott-auth-code';
